export default __webpack_public_path__ + "static/media/Problem-Solving.f3900ec5.svg";